import React from 'react';

const PasswordForgetLink = () => (
  <p>
    <a href="/passwordforget">Forgot Password?</a>
  </p>);

export default PasswordForgetLink;



// WEBPACK FOOTER //
// ./src/components/UserManagement/PasswordForgetLink.js